export default class MobileBox {
    private $el: JQuery;

    public constructor() {
        this.initHtml();
    }

    public open(): void {
        this.$el.addClass('mobilebox--opened');
    }

    public close(): void {
        this.$el.removeClass('mobilebox--opened');
    }

    public initHtml(): void {
        this.$el = $('.mobilebox');

        const $close = $('.mobilebox__close', this.$el);

        $close.on('click', (e) => {
            this.close();
        });

        const $menu = $('.menu', this.$el);

        $('.children', $menu).each((ix, el) => {
            const $el = $(el);

            const level = $el.parents('.children').length;

            const $head = $('> .head', $el);
            const $title = $('.title', $head);
            $title.append($('<i class="fa fa-arrow-right">'));
            const $submenu = $('> .submenu', $el);

            const slideFunc = (level: number, onsuccess?: () => void): void => {
                $menu.css({
                    'transform': 'translateX(-' + (100 * (level)) + '%)',
                });

                if (onsuccess != null) {
                    setTimeout(onsuccess, 600);
                }
            };

            const $back = $(`
                <li class="item back">
                    <div class="head">
                        <a href="#" class="title">
                            <i class="fa fa-arrow-left"></i>
                            <span></span>
                        </a>
                    </div>
                </li>
            `);

            $('span', $back).text(this.$el.data('backtitle'));

            $back.prependTo($submenu);

            $back.on('click', (e) => {
                e.preventDefault();

                slideFunc(level, () => {
                    $submenu.hide();
                });
            });

            $title.on('click', (e) => {
                e.preventDefault();
            });

            $head.on('click', (e) => {
                $submenu.show();

                slideFunc(level + 1);
            });
        });
    }
}
